import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface DteTestProgressList {
    id: number;
    requirementType: string;
    documentName: string;
    documentCode?: string | null;
    requiredCount: number;
    completedCount: number;
    completed: boolean;
}

export interface DteTestProgressForm {
    id: number | null;
    requirementId: number | null;
    requirementType: string | null;
    documentName: string | null;
    documentCode: string | null;

    requiredCount: number | null;
    completedCount: number | null;
    completed: boolean | null;
}

export interface DteTestProgressFormErrors {
    completedCount?: string;
}

interface State {
    list: DteTestProgressList[];
    form: DteTestProgressForm;
    formErrors: DteTestProgressFormErrors;
    isSubmit: boolean;
    isEditModalOpen: boolean;
}

export const initialForm: DteTestProgressForm = {
    id: null,
    completedCount: null,
    completed: null,
    requirementId: null,
    requirementType: null,
    documentName: null,
    documentCode: null,
    requiredCount: null
};

const initialState: State = {
    list: [],
    form: initialForm,
    formErrors: {},
    isSubmit: false,
    isEditModalOpen: false,
};

export const testProgressAdminSlice = createSlice({
    name: "testProgressAdmin",
    initialState,
    reducers: {
        // ===========================
        // LIST
        // ===========================
        setTestProgressList: (state, action: PayloadAction<DteTestProgressList[]>) => {
            state.list = action.payload;
        },

        updateProgressInList: (state, action: PayloadAction<DteTestProgressList>) => {
            state.list = state.list.map(item =>
                item.id === action.payload.id ? action.payload : item
            );
        },

        setFormFromDetail: (state, action: PayloadAction<any>) => {
            state.form = {
                id: action.payload.id,
                requirementId: action.payload.requirementId,
                requirementType: action.payload.requirementType,
                documentName: action.payload.documentName,
                documentCode: action.payload.documentCode,
                requiredCount: action.payload.requiredCount,
                completedCount: action.payload.completedCount,
                completed: action.payload.completed,
            };
            state.formErrors = {};
        },


        updateFormField: (
            state,
            action: PayloadAction<{ field: keyof DteTestProgressForm; value: any }>
        ) => {
            (state.form[action.payload.field] as any) = action.payload.value;
        },

        resetForm: (state) => {
            state.form = initialForm;
            state.formErrors = {};
            state.isSubmit = false;
        },

        // ===========================
        // ERRORS
        // ===========================
        setFormErrors: (state, action: PayloadAction<DteTestProgressFormErrors>) => {
            state.formErrors = action.payload;
        },

        clearFormErrors: (state) => {
            state.formErrors = {};
        },

        // ===========================
        // SUBMIT STATUS
        // ===========================
        setSubmit: (state, action: PayloadAction<boolean>) => {
            state.isSubmit = action.payload;
        },

        // ===========================
        // MODAL CONTROL
        // ===========================
        openEditModal: (state) => {
            state.isEditModalOpen = true;
        },

        closeEditModal: (state) => {
            state.isEditModalOpen = false;
        },
    },
});

export const {
    setTestProgressList,
    updateProgressInList,
    setFormFromDetail,
    updateFormField,
    resetForm,
    setFormErrors,
    clearFormErrors,
    setSubmit,
    openEditModal,
    closeEditModal,
} = testProgressAdminSlice.actions;

export default testProgressAdminSlice.reducer;
